<template>
    <z-basePage :title="'充值记录'">
        <div class="tab-title">
            <div class="tab-btn" :class="{active:activeIndex==0}" @click="changeTab(0)">奖金充值记录</div>
            <div class="tab-btn" :class="{active:activeIndex==1}" @click="changeTab(1)">预算充值记录</div> 
            <div class="tab-btn" :class="{active:activeIndex==2}" @click="changeTab(2)">职级充值记录</div> 
        </div>

        <div class='tab'>
            <bonusNote class="tab-main" :activeIndex="activeIndex" :index="0"></bonusNote>
            <budgetNote class="tab-main" :activeIndex="activeIndex" :index="1"></budgetNote>
            <rankNote class="tab-main" :activeIndex="activeIndex" :index="2"></rankNote>
        </div>
        
    </z-basePage>
</template>

<script>
    import bonusNote from './bonus-note.vue'
    import budgetNote from './budget-note.vue'
    import rankNote from './rank-note.vue'

    export default {
        components:{
            bonusNote,
            budgetNote,
            rankNote,
        },
        data(){
            return {

            }
        },
        computed:{
            activeIndex(){
                return this.$route.query.tab || 0;
            },
        },
        methods:{
            changeTab(index){
                this.$router.replace({
                    name:'back-finance-note',
                    query:{
                        tab:index,
                    }
                })
            },
        },
    }
</script>

<style lang="less" scoped>
    .tab{
        height:calc(~"100% - 40px");  //去除tab
        .tab-main{
            padding-top: 0.1px;
            height:100%;
        }
    }
</style>





// WEBPACK FOOTER //
// page-note.vue?77e43a38